// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__KwMVm","subTitle":"Modal_subTitle__7OYiq","modal":"Modal_modal__0LUyk","divider":"Modal_divider__fag8E","confirmation":"Modal_confirmation__EAPkZ"};